import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

const STORAGE_KEY = 'ogrn_dark_mode';

@Injectable({ providedIn: 'root' })
export class ThemeService {

  private readonly _darkMode$ = new BehaviorSubject<boolean>(
    localStorage.getItem(STORAGE_KEY) === 'true'
  );

  constructor() {
    document.body.classList.toggle('dark-mode', this._darkMode$.getValue());
  }
  darkMode$ = this._darkMode$.asObservable(); // On expose un Observable pour que les composants puissent s'abonner

  setDarkMode(enabled: boolean): void {
    this._darkMode$.next(enabled);
    document.body.classList.toggle('dark-mode', enabled);
    localStorage.setItem(STORAGE_KEY, String(enabled));
  }
}
